export default __webpack_public_path__ + "static/media/replay.beebcd0b.svg";